<template>
  <div class="col-md-12">
    <div class="card riv-card-back m-b-30">
      <div class="riv-card-back__inner">
       
        <div class="col-md-5 offset-md-5">
          <img src="/assets/img/ohis_logo.png" class="avatar avatar-xl" alt="RIVCHPP Logo" />
        </div>

        <div class="riv-card-back__body">
          <p>
            This card remains the property of Rivers State Contributory Health Protection Programme
          </p>
          <p>
            If found pls return to: Remodelled Waterlines Building, Aba Expressway, Port Harcourt or contact us via:
            09046962204, 02018891465, 08085318664.
          </p>
        </div>

        <div class="riv-card-back__footer">
          <div class="riv-card-back__signatory">
            <div class="riv-card-back__line"></div>
            <p>AUTHORIZED SIGNATORY</p>
          </div>
          <div class="riv-card-back__qr">
            <qrcode-vue :value="verifyUrl" :size="84" :level="'H'" render-as="svg"></qrcode-vue>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import QRCodeVue from "qrcode.vue";

  export default {
    name: "EnrolleeCardBack",
    components: {
      qrcodeVue: QRCodeVue,
    },
    props: {
      verifyUrl: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped>
  .riv-card-back {
    border-radius: 18px;
    border: 2px solid #b9c0c7;
    background: linear-gradient(165deg, #ffffff 0%, #f5f7f9 100%);
  }

  .riv-card-back__inner {
    padding: 24px;
    min-height: 540px;
    display: flex;
    flex-direction: column;
  }

  .riv-card-back__logo-wrap {
    text-align: center;
    margin-bottom: 14px;
  }

  .riv-card-back__logo {
    width: 110px;
    height: 110px;
    object-fit: contain;
  }

  .riv-card-back__body {
    text-align: center;
    color: #111;
    font-weight: 700;
    line-height: 1.35;
    letter-spacing: 0.2px;
    font-size: 1.85rem;
  }

  .riv-card-back__body p {
    margin-bottom: 10px;
  }

  .riv-card-back__footer {
    margin-top: auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
  }

  .riv-card-back__signatory {
    width: 100%;
    max-width: 460px;
    text-align: center;
  }

  .riv-card-back__line {
    border-top: 2px dashed #111;
    margin-bottom: 8px;
  }

  .riv-card-back__signatory p {
    margin: 0;
    font-size: 1.65rem;
    font-weight: 800;
  }

  .riv-card-back__qr {
    flex-shrink: 0;
    width: 84px;
    height: 84px;
  }

  @media (max-width: 767px) {
    .riv-card-back__inner {
      min-height: 420px;
    }

    .riv-card-back__body {
      font-size: 1.15rem;
    }

    .riv-card-back__signatory p {
      font-size: 1rem;
    }
  }

  @media print {
    .riv-card-back {
      page-break-before: always;
      break-before: page;
    }

    .riv-card-back__inner {
      min-height: 88vh;
    }

    .riv-card-back__body {
      font-size: 24px;
    }

    .riv-card-back__signatory p {
      font-size: 22px;
    }
  }
</style>
